import { defineComponent as u, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as m, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, k = { key: 3 }, w = { key: 4 }, y = { key: 5 }, H = {
  name: "ScalarIconCloud"
}, C = /* @__PURE__ */ u({
  ...H,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = g(s);
    return (p, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      m(p.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", h, t[0] || (t[0] = [
        n("path", { d: "M160,36A92.09,92.09,0,0,0,79,84.36,68,68,0,1,0,72,220h88a92,92,0,0,0,0-184Zm0,160H72a44,44,0,0,1-1.82-88A91.86,91.86,0,0,0,68,128a12,12,0,0,0,24,0,68,68,0,1,1,68,68Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M240,128a80,80,0,0,1-80,80H72A56,56,0,1,1,85.92,97.74l0,.1A80,80,0,0,1,240,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        n("path", { d: "M160.06,40A88.1,88.1,0,0,0,81.29,88.67h0A87.48,87.48,0,0,0,72,127.73,8.18,8.18,0,0,1,64.57,136,8,8,0,0,1,56,128a103.66,103.66,0,0,1,5.34-32.92,4,4,0,0,0-4.75-5.18A64.09,64.09,0,0,0,8,152c0,35.19,29.75,64,65,64H160a88.09,88.09,0,0,0,87.93-91.48C246.11,77.54,207.07,40,160.06,40Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        n("path", { d: "M160,42A86.11,86.11,0,0,0,82.43,90.88,62,62,0,1,0,72,214h88a86,86,0,0,0,0-172Zm0,160H72a50,50,0,0,1,0-100,50.67,50.67,0,0,1,5.91.35A85.61,85.61,0,0,0,74,128a6,6,0,0,0,12,0,74,74,0,1,1,74,74Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        n("path", { d: "M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        n("path", { d: "M160,44A84.11,84.11,0,0,0,83.59,93.12,60.71,60.71,0,0,0,72,92a60,60,0,0,0,0,120h88a84,84,0,0,0,0-168Zm0,160H72a52,52,0,1,1,8.55-103.3A83.66,83.66,0,0,0,76,128a4,4,0,0,0,8,0,76,76,0,1,1,76,76Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  C as default
};
